<template>
  <div class="more-photos-counter u-absolute-full">
    <div class="more-photos-counter__count">+{{ count }}</div>
  </div>
</template>

<script>
export default {
  props: {
    count: {
      type: Number,
      required: true,
    },
  },
};
</script>

<style lang="scss" scoped>
.more-photos-counter {
  background-color: rgba(var.$pitch-black, 0.5);
  display: flex;
  align-items: center;
  justify-content: center;
  transition: var.$transition-slow;

  &:hover {
    background-color: rgba(var.$pitch-black, 0.6);
  }

  &__count {
    font-family: var.$font-family-sf-pro-display;
    font-weight: bold;
    font-size: 40px;
    color: var.$white;
  }
}
</style>
